import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Input } from '../components/input';
import { Select } from '../components/select';


const departmentList = [
  "scaffolding",
  "insulation",
  "production",
  "administration",
];

export function UserInformation() {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <Input
        name="name"
        placeholder={t('placeholder.name')}
        icon={(
          <UserOutlined />
        )}
      />
      <Input
        name="surname"
        placeholder={t('placeholder.surname')}
        icon={(
          <UserOutlined />
        )}
      />
      <Select
        label={t("placeholder.department")}
        placeholder={t("placeholder.department")}
        name="department"
        namespace="department"
        options={departmentList}
      />

    </React.Fragment>
  );
}
